













































































import {Component, Mixins} from "vue-property-decorator";
import {BasicMixin} from "@/mixins/AdminMixin";
import CardHeader from "@/components/CardHeader.vue"
import {CrucigramaListInterface} from "@/models/Crucigrama";
import {State} from "vuex-class";

@Component({
    components:{
        CardHeader
    }
})
export default class ManagmentCrucigrama extends Mixins(BasicMixin){
    @State(state => state.game.crucigramaList) crucigramas: CrucigramaListInterface[];


    public headers = [
        {
            text: 'Titulo',
            align: 'left',
            sortable: true,
            value: 'title',
        },
        { text: 'Opciones', value: 'actions' },
    ];

    public crucigrama: CrucigramaListInterface = {
        title: '',
    };


    openModal(edit: boolean, item: CrucigramaListInterface | any) {
        this.edit = edit;
        this.dialog = true;
        if (edit) {
            this.idModel = item.id;
            this.crucigrama = {
                title: item.title,
            }
        } else {
            this.crucigrama = {
                title: '',
            }
        }
    }

    formSubmit(){
        if (this.edit){
            this.$store.dispatch('editCollect', {id: this.idModel, data: this.crucigrama, collection: 'crucigramaList'});
            this.text = 'Se ha editado el juego';
            this.dialog = false;
            this.snackbar = true;
        } else {
            this.$store.dispatch('createdCrucigramaList', this.crucigrama);
            this.text = 'Se ha creado el juego';
            this.dialog = false;
            this.snackbar = true;
        }

    }

    deleteItem(item: CrucigramaListInterface){
        this.$store.dispatch('deleteCollect', {id:item.id, collection:'crucigramaList'})
    }

    created(){
        this.$store.dispatch('bindCrucigramaList', 'desc');

    }
}
